import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setFunctionField, deleteFunction } from 'actions/feature/functions'
import {
  getFunctionDescription,
  getFunctionMarkedForDeletion,
} from 'selectors/feature/functions'
import {
  getFeatureModuleType,
  getInDesignStatus,
} from 'selectors/feature/featureMetadata'
import { getValidationDescriptions } from 'selectors/feature/features'
import FunctionEditor from './FunctionEditor'

const mapStateToProps = (state, ownProps) => {
  const { id: fnId } = ownProps
  const description = getFunctionDescription(fnId)(state)
  const markedForDeletion = getFunctionMarkedForDeletion(fnId)(state)
  const moduleType = getFeatureModuleType(state)
  const featureInDesign = getInDesignStatus(state)
  const allDescriptions = getValidationDescriptions(state)

  return {
    fnId,
    description,
    markedForDeletion,
    moduleType,
    featureInDesign,
    allDescriptions,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { id: fnId, parentId: featureId } = ownProps

  return {
    ...bindActionCreators(
      {
        deleteFunction: () => deleteFunction({ featureId, functionId: fnId }),
        updateDescription: (value) =>
          setFunctionField(fnId, 'description', value),
        toggleMarkForDeletion: (toDelete) =>
          setFunctionField(fnId, 'markedForDeletion', toDelete),
      },
      dispatch
    ),
  }
}

const FunctionEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FunctionEditor)

export default FunctionEditorContainer
